// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ee0A","content":"styles_content__15s0v"};